import React from 'react';
import { Input, Label, FormGroup, Form, Alert, Button, ButtonGroup, InputGroup } from 'reactstrap';
import { Popover } from '@mui/material';

export const TemplateDeleteConfirmPopover = props => {
    return (
        <Popover
            id={props.popoverURLAncor && 'simple-popover'}
            open={props.popoverURLAncor}
            anchorEl={props.popoverURLAncor}
            onClose={props.handlePopoverURLClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
        >
            <div style={{ padding: 20 }}>
                <p style={{ fontSize: '.9rem' }}>Are you sure you want to delete this template?</p>
                <ButtonGroup style={{ marginTop: 20 }}>
                    <Button color="danger" onClick={props.handlePopoverConfirm}>
                        Yes
                    </Button>
                    <Button color="secondary" onClick={props.toggle}>
                        No
                    </Button>
                </ButtonGroup>
            </div>
        </Popover>
    )
}